import { SVGProps } from 'react'

const BeautifyIcon = (props: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-icon"
    style={{
      verticalAlign: 'middle',
      fill: 'currentColor',
      overflow: 'hidden'
    }}
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path d="M512 293.669a30.476 30.476 0 0 1-30.476-30.477V30.476a30.476 30.476 0 0 1 60.952 0v232.716A30.476 30.476 0 0 1 512 293.67zm0 730.33a30.476 30.476 0 0 1-30.476-30.475V760.808a30.476 30.476 0 0 1 60.952 0v232.716A30.476 30.476 0 0 1 512 1024zM263.192 542.477H30.476a30.476 30.476 0 0 1 0-60.952h232.716a30.476 30.476 0 1 1 0 60.952zm730.332 0H760.808a30.476 30.476 0 0 1 0-60.952h232.716a30.476 30.476 0 0 1 0 60.952zM687.909 366.568a30.476 30.476 0 0 1-21.517-52.054l164.572-164.571a30.476 30.476 0 0 1 43.093 43.093L709.486 357.608a30.476 30.476 0 0 1-21.577 8.96zM171.52 882.956a30.476 30.476 0 0 1-21.577-51.992l164.571-164.572a30.476 30.476 0 0 1 43.094 43.094L193.036 874.057a30.476 30.476 0 0 1-21.516 8.9zm164.571-516.388a30.476 30.476 0 0 1-21.577-8.96L149.943 193.036a30.476 30.476 0 0 1 43.093-43.093l164.572 164.571a30.476 30.476 0 0 1-21.517 52.054zM993.524 1024a30.476 30.476 0 0 1-21.577-8.9L490.423 533.578a30.476 30.476 0 0 1 43.154-43.154l481.524 481.524A30.476 30.476 0 0 1 993.524 1024z" />
  </svg>
)
export default BeautifyIcon
